import {createAction, handleActions} from "redux-actions";
import createRequestSaga, {createRequestActionTypes} from "../lib/createRequestSaga";
import * as addrAPI from "../lib/api/address";
import { takeLatest } from 'redux-saga/effects';

const INITIALIZE_FORM = 'addr/INITIALIZE_FORM';
const [SEARCH, SEARCH_SUCCESS, SEARCH_FAILURE] = createRequestActionTypes('addr/SEARCH');

export const searchAddress = createAction(SEARCH, keyword => keyword);
export const initializeForm = createAction(INITIALIZE_FORM, form => form);

const jusoSaga = createRequestSaga(SEARCH, addrAPI.addrSearch);
export function* addrSaga() {
    yield takeLatest(SEARCH, jusoSaga);
}

const initialState = {
    address: [],
    errorCode: "",
    errorMessage: ""
};

const address = handleActions(
    {
        [INITIALIZE_FORM]: (state, {payload: data}) => ({
            ...state,
            address: initialState.address,
            errorCode: "",
            errorMessage: ""
        }),
        [SEARCH_SUCCESS]: (state, {payload: data}) => ({
            ...state,
            address: data.results.juso,
            errorCode: data.results.common.errorCode,
            errorMessage: data.results.common.errorMessage
        }),
        [SEARCH_FAILURE]: (state, {payload: error}) => ({
            ...state,
            error
        })
    },
    initialState
);

export default address;
